import useLocation from 'react-use/esm/useLocation'

export const useConversationUuid = (uuidToUse?: string) => {
  const { pathname = '' } = useLocation()
  const currentUuid = pathname.split('/').pop() || ''
  return uuidToUse || currentUuid
}
